module.exports = __webpack_public_path__ + "static/media/ltc.72e6e51e.svg";